module.exports = "pegasus_template/assets/preview-17.png";